import { useEffect } from 'react';

import { H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';

import { Overlay } from '../Overlay';
import { getMyHubsU1Academy } from '../Portfolio.actions';

import { U1AcademyItem } from './U1AcademyItem';

export const U1AcademySummary = () => {
  const dispatch = useDispatch();

  const { u1academy } = useAppSelector((state) => state.portfolio);

  const isAllActive = u1academy?.orders?.some(
    (item: { isActive: boolean }) => item.isActive === true
  );

  useEffect(() => {
    dispatch(getMyHubsU1Academy());
  }, [dispatch]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        dispatch(getMyHubsU1Academy());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <H3 mbSM='10' color={colors.primary900}>
          U1 Academy
        </H3>
        <Button negative disabled maxWidth='250px' maxWidthSM='100%'>
          ADD U1 ACADEMY
        </Button>
      </Flexed>

      <div>
        {u1academy?.orders?.map((item: any, index: number) => (
          <U1AcademyItem key={index} item={item} isAllActive={isAllActive} />
        ))}
      </div>

      {u1academy?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};
